import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../../api';

const AreaDropdown = ({ locationId, value, onChange }) => {
  const [areas, setAreas] = useState([]);

  useEffect(() => {
    const fetchAreas = async () => {
      if (!locationId) {
        setAreas([]); // Clear areas if no location selected
        return;
      }

      try {
        const response = await axiosInstance.get(`/location-based-area/${locationId}`);
        const areaData = response.data?.data || response.data || [];
        setAreas(areaData);
      } catch (error) {
        console.error('Error fetching areas:', error);
      }
    };

    fetchAreas();
  }, [locationId]); // Run only when locationId changes

  return (
    <div className="mb-3">
      <select
        name="area_id"
        value={value}
        onChange={onChange}
        className="form-select"
        disabled={!locationId}
      >
        <option value="">Select Area</option>
        {areas.map((area) => (
          <option key={area.id} value={area.id}>
            {area.area_name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default AreaDropdown;
